import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { mobileShareService } from '../services/mobileShareService';
import { useApiError } from '../../shared/hooks/useApiError';
import { MessageDialog } from '../../shared/ui';
import SatsueiMemoForm from '../components/SatsueiMemoForm';

/**
 * AppShareコンポーネントのスタイル定義
 * シェア画面の全体的なレイアウトと各要素のスタイルを定義
 */
const styles = {
  // メインコンテナ
  container: {
    height: '100%',
    display: 'block',
    overflowY: 'scroll',
    WebkitOverflowScrolling: 'touch'
  },
  // ローディング画面
  loading: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999
  },
  // ヘッダー部分
  detailHeader: {
    width: '100%',
    height: '60px',
    position: 'fixed',
    top: 0
  },
  // ヘッダー左側エリア
  headerLeft: {
    float: 'left'
  },
  // ヘッダー右側エリア
  headerRight: {
    float: 'right',
    margin: '0px 5px'
  },
  objectIdArea: {
    margin: '7px 0 0 14px',
    display: 'inline-block'
  },
  objectIdAreaTitle: {
    color: '#FFF',
    background: '#2B2222',
    fontWeight: 'bold',
    fontSize: '8pt',
    padding: '4px 12px',
    textAlign: 'center',
    float: 'left',
    border: '1px solid #FFF'
  },
  objectIdAreaBody: {
    color: '#2B2222',
    background: '#FFF',
    fontWeight: 'bold',
    fontSize: '8pt',
    float: 'left',
    padding: '4px 12px',
    textAlign: 'center',
    minWidth: '60px',
    border: '1px solid #FFF'
  },
  logoArea: {
    margin: '7px 0 0 14px',
    display: 'flex',
    alignItems: 'center'
  },
  logoImage: {
    height: '50px',
    width: 'auto',
    objectFit: 'contain'
  },
  imageMainAreaHeader: {
    position: 'relative',
    top: '60px'
  },
  switchImageButtonArea: {
    padding: '6px',
    backgroundColor: '#2B2222',
    float: 'left',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  switchImageButton: {
    width: '32px',
    height: '32px',
    display: 'inline-block',
    backgroundImage: 'url("/core/img/icon/icon-photo-camera.png")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center'
  },
  switchMovieButtonArea: {
    padding: '6px',
    backgroundColor: '#EEE',
    float: 'left',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer'
  },
  switchMovieButton: {
    width: '32px',
    height: '32px',
    display: 'inline-block',
    backgroundImage: 'url("/core/img/icon/icon-video-camera.png")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
  },
  imageArea: {
    position: 'relative',
    top: '60px'
  },
  movieArea: {
    position: 'relative',
    top: '60px'
  },
  imageMainAreaTop: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '4px',
    backgroundColor: '#000'
  },
  satsueiKanryoJikoku: {
    fontSize: '11px',
    color: '#FFF'
  },
  satsueiMaisu: {
    fontSize: '11px',
    color: '#FFF'
  },
  imageMainArea: {
    position: 'relative',
    textAlign: 'center',
    width: '100%',
    aspectRatio: '1',
    backgroundColor: '#2B2222',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  imageMainAreaMisatsuei: {
    position: 'relative',
    textAlign: 'center',
    width: '100%',
    backgroundColor: '#2B2222',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  misatsuei: {
    backgroundColor: '#DDD',
    border: '1px solid #FFF',
    margin: '20px auto',
    width: '90%'
  },
  message: {
    fontSize: '16px',
    color: '#666',
    margin: '40px 5px'
  },
  imageMain: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
    display: 'block'
  },
  imageTagArea: {
    padding: '8px 10px',
    background: '#f9f9f9',
    borderTop: '1px solid #ddd',
    borderBottom: '1px solid #ddd'
  },
  imageTag: {
    fontSize: '12px',
    color: '#333',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px'
  },
  tagItem: {
    display: 'inline-block',
    background: '#e0e0e0',
    color: '#333',
    padding: '2px 8px',
    borderRadius: '12px',
    fontSize: '11px',
    margin: '1px'
  },
  imageMainAreaBottom: {
    padding: '4px',
    background: '#000'
  },
  satsueiBasho: {
    fontSize: '11px',
    color: '#FFF',
    textAlign: 'right'
  },
  imageThumbnailArea: {

  },
  imageThumbnail: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    overflowX: 'auto'
  },
  thumbnailItem: {
    flex: '0 0 auto',
    width: '70px',
    height: '70px',
    border: '2px solid #ddd',
    borderRadius: '5px',
    cursor: 'pointer',
    overflow: 'hidden'
  },
  thumbnailImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    background: '#2B2222'
  },
  movieMainArea: {
    position: 'relative',
    textAlign: 'center',
    width: '100%',
    aspectRatio: '1',
    backgroundColor: '#2B2222',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  movieMainAreaTop: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '4px',
    backgroundColor: '#000'
  },
  movieMainAreaBottom: {
    padding: '4px',
    background: '#000'
  },
  movieMainAreaMisatsuei: {
    position: 'relative',
    textAlign: 'center',
    width: '100%',
    backgroundColor: '#2B2222',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  movieMain: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
    display: 'block'
  },
  movieThumbnailArea: {

  },
  movieThumbnail: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    overflowX: 'auto'
  },
  movieThumbnailItem: {
    flex: '0 0 auto',
    width: '70px',
    height: '70px',
    border: '2px solid #ddd',
    borderRadius: '5px',
    cursor: 'pointer',
    overflow: 'hidden',
    position: 'relative'
  },
  movieThumbnailImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    background: '#2B2222'
  },
  moviePlayIcon: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '20px',
    height: '20px',
    backgroundImage: 'url("/core/img/icon/play-icon.png")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center'
  },
  selector: {
    padding: '20px 20px 1px 20px',
    background: 'white',
    position: 'relative',
    top: '60px',
  },
  satsueiMemoCategoryArea: {
    marginBottom: '20px'
  },
  satsueiMemoCategoryAreaTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    marginBottom: '10px',
    color: '#333',
    backgroundColor: '#FFE4E1',
    padding: '5px 10px',
    borderRadius: '3px'
  },
  select: {
    width: '100%',
    padding: '12px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '14px',
    backgroundColor: 'white'
  },
  satsueiGuideArea: {
    marginBottom: '20px'
  },
  satsueiGuideAreaTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    marginBottom: '10px',
    color: '#333',
    backgroundColor: '#FFE4E1',
    padding: '5px 10px',
    borderRadius: '3px'
  },
  kyotenListArea: {
    marginBottom: '20px'
  },
  kyotenListAreaTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    marginBottom: '10px',
    color: '#333',
    backgroundColor: '#FFE4E1',
    padding: '5px 10px',
    borderRadius: '3px'
  },
  satsueiMemoArea: {
    padding: '40px 20px 20px',
    background: 'white'
  },
  satsueiMemoAreaTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    marginBottom: '10px',
    color: 'white',
    backgroundColor: 'black',
    marginTop: '25px',
    padding: '5px 10px'
  },
  satsueiMemoForm: {
    marginBottom: '20px'
  },
  satsueiMemoFormUl: {
    listStyle: 'none',
    padding: 0,
    margin: 0
  },
  satsueiMemoFormLi: {
    marginBottom: '15px'
  },
  satsueiMemoFormLabel: {
    fontSize: '16px',
    fontWeight: 'bold',
    marginBottom: '10px',
    color: '#333',
    backgroundColor: '#FFE4E1',
    padding: '8px 12px',
    borderRadius: '5px',
    display: 'block'
  },
  satsueiMemoFormColumn: {
    marginBottom: '15px'
  },
  satsueiMemoFormTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    marginBottom: '8px',
    color: '#333'
  },
  satsueiMemoFormValue: {
    marginBottom: '10px'
  },
  satsueiMemoFormInput: {
    width: '100%',
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '14px',
    boxSizing: 'border-box',
    backgroundColor: '#f5f5f5',
    color: '#666'
  },
  satsueiMemoFormTextarea: {
    width: '100%',
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '14px',
    resize: 'vertical',
    minHeight: '80px',
    boxSizing: 'border-box',
    backgroundColor: '#f5f5f5',
    color: '#666'
  },
  satsueiMemoFormSelect: {
    width: '100%',
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '14px',
    backgroundColor: '#f5f5f5',
    color: '#666',
    boxSizing: 'border-box'
  },
  satsueiMemoFormRadioGroup: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px'
  },
  satsueiMemoFormRadio: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 12px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    cursor: 'default',
    backgroundColor: '#f5f5f5',
    color: '#666',
    transition: 'all 0.2s ease'
  },
  satsueiMemoFormRadioChecked: {
    backgroundColor: '#E0E0E0',
    borderColor: '#CCC'
  },
  satsueiMemoFormCheckbox: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 12px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    cursor: 'default',
    backgroundColor: '#f5f5f5',
    color: '#666',
    transition: 'all 0.2s ease',
    marginBottom: '5px'
  },
  satsueiMemoFormCheckboxChecked: {
    backgroundColor: '#E0E0E0',
    borderColor: '#CCC'
  },
  code: {
    fontSize: '9pt',
    fontWeight: 'bold',
    padding: '3px',
    position: 'relative',
    top: '3px',
    right: '5px'
  }
};

/**
 * AppShareコンポーネント
 * シェアされたオブジェクトの詳細表示を行う閲覧専用コンポーネント
 * 
 * @param {Function} onClose - コンポーネントを閉じる際のコールバック関数
 */
const AppShare = () => {
  const location = useLocation();
  
  // APIエラーハンドリング用のフック
  const { 
    showErrorDialog,
    errorMessage,
    handleApiError,
    closeErrorDialog
  } = useApiError(() => setIsLoading(false));

  // 関数の参照を安定化
  const handleApiErrorRef = useRef(handleApiError);

  useEffect(() => {
    handleApiErrorRef.current = handleApiError;
  }, [handleApiError]);
  
  // URLパラメータからshareCodeを取得
  const urlParams = new URLSearchParams(location.search);
  const shareCode = urlParams.get('shareCode'); // シェアコード
  
  // 基本状態管理
  const [selectFlg, setSelectFlg] = useState(0); // 表示モード（0: 画像, 1: 動画）
  const [imageLength, setImageLength] = useState(0); // 画像枚数
  const [isLoading, setIsLoading] = useState(false); // ローディング状態
  
  // シェア関連の情報管理
  const [objectId, setObjectId] = useState(''); // オブジェクトID
  const [pixId, setPixId] = useState(''); // PIX ID
  const [kyotenName, setKyotenName] = useState(''); // 拠点名

  // フォーム入力データ（閲覧専用）
  const [satsueiMemoCategory, setSatsueiMemoCategory] = useState(''); // 撮影メモカテゴリー
  const [satsueiGuide, setSatsueiGuide] = useState(''); // 撮影ガイド
  const [hozonFolder, setHozonFolder] = useState(99); // 保存フォルダ
  
  // 画像・動画データの状態管理
  const [images, setImages] = useState([]); // 画像URL配列
  const [imageData, setImageData] = useState([]); // 画像の詳細データ（サムネイル用）
  const [currentImageIndex, setCurrentImageIndex] = useState(0); // 現在選択中の画像インデックス
  const [movies, setMovies] = useState([]); // 動画データ配列
  const [currentMovieIndex, setCurrentMovieIndex] = useState(0); // 現在選択中の動画インデックス
  const [imageTags, setImageTags] = useState({}); // 画像タグデータ
  const [folderImageCounts, setFolderImageCounts] = useState({}); // 各フォルダの画像枚数
  const [totalImageCount, setTotalImageCount] = useState(0); // 全画像枚数
  
  // ドロップダウンオプションの状態管理
  const [satsueiMemoCategories, setSatsueiMemoCategories] = useState([]); // 撮影メモカテゴリーリスト
  const [satsueiGuides, setSatsueiGuides] = useState([]); // 撮影ガイドリスト
  const [hozonFolders, setHozonFolders] = useState([]); // 保存フォルダリスト
  
  // 撮影メモフォーム関連の状態管理
  const [satsueiMemoColumns, setSatsueiMemoColumns] = useState([]); // 撮影メモカラム定義

  /**
   * 各フォルダの画像枚数を計算する関数
   * シェア用の画像フォルダごとの画像枚数を取得し、合計枚数を計算
   * @param {Array} folders - フォルダリスト
   * @param {string} pixId - PIX ID
   * @param {string} objectId - オブジェクトID
   */
  const calculateFolderImageCounts = useCallback(async (folders, pixId, objectId) => {
    try {
      const counts = {};
      let totalCount = 0;
      
      // 全フォルダの画像枚数を取得
      for (const folder of folders) {
        const folderId = folder.imageFolderId;
        const imageData = await mobileShareService.getObjectImageListForShare(objectId, pixId, folderId);
        
        if (imageData && imageData.objectDatas && imageData.objectDatas.length > 0) {
          const objectImages = imageData.objectDatas[0].objectImages;
          const folderCount = objectImages ? objectImages.length : 0;
          counts[folderId] = folderCount;
          totalCount += folderCount;
        } else {
          counts[folderId] = 0;
        }
      }
      
      setFolderImageCounts(counts);
      setTotalImageCount(totalCount);
    } catch (error) {
      // エラーログは削除（本番環境では不要）
    }
  }, []);

  /**
   * 画像タグの読み込み
   * 指定された画像のタグ情報を取得
   * @param {string} pixId - PIX ID
   * @param {string} objectId - オブジェクトID
   * @param {string} objectImageId - オブジェクト画像ID
   * @param {number} imageIndex - 画像インデックス
   */
  const loadImageTags = useCallback(async (pixId, objectId, objectImageId, imageIndex) => {

    try {
      const tagData = await mobileShareService.getObjectImageTag(objectId, objectImageId, pixId);

      if(tagData.returnCode !== '200'){
        // エラーの場合は空配列を設定
        setImageTags(prev => ({
          ...prev,
          [imageIndex]: []
        }));
        return;
      }
      
      // レスポンスからimageTagListを取得し、imageTagId順にソートしてimageTagプロパティの配列に変換
      if (tagData.imageTagList && tagData.imageTagList.length > 0) {
        const sortedTags = tagData.imageTagList
          .sort((a, b) => a.imageTagId - b.imageTagId)
          .map(tag => tag.imageTag);
        
        // 指定された画像のタグを更新
        setImageTags(prev => {
          const newTags = {
            ...prev,
            [imageIndex]: sortedTags
          };
          return newTags;
        });
      } else {
        // タグがない場合は空配列を設定
        setImageTags(prev => ({
          ...prev,
          [imageIndex]: []
        }));
      }
    } catch (error) {
      // エラーの場合は空配列を設定
      setImageTags(prev => ({
        ...prev,
        [imageIndex]: []
      }));
    }
  }, []);

  // 動画選択時の処理
  const handleMovieSelect = useCallback((movieIndex) => {
    if (movies && movies[movieIndex]) {
      setCurrentMovieIndex(movieIndex);
    }
  }, [movies]);

  /**
   * 画像データの読み込み
   * シェア用の画像一覧を取得し、シェア専用URLを生成
   * @param {string} pixId - PIX ID
   * @param {string} objectId - オブジェクトID
   */
  const loadImage = useCallback(async (pixId, objectId) => {
    try {
      // 画像一覧を取得
      const imageData = await mobileShareService.getObjectImageListForShare(objectId, pixId);

      if(imageData.returnCode !== '200'){
        MessageDialog.show('エラー', '画像の取得に失敗しました。', null, 'error');
        return;
      }
      
      if (imageData && imageData.objectDatas && imageData.objectDatas.length > 0) {
        const objectImages = imageData.objectDatas[0].objectImages;
        
        if (objectImages && objectImages.length > 0) {
          // 画像データをblobとして取得（AppSearch.jsxと同じ方法）
          const imagePromises = objectImages.map(async (image, index) => {
            if (image.isUploaded === 0) {
              // アップロード未完了の画像: プレースホルダーアイコンを表示
              return {
                ...image,
                imageIndex: index,
                mainImageUrl: '/core/img/sendingimage.png',
                thumbnailUrl: '/core/img/sendingimage.png'
              };
            } else if (image.objectImageId !== undefined 
              && image.objectImageId !== null && image.objectImageId !== '') {
              // アップロード済みの画像（blobとして取得）
              try {
                const blobUrl = await mobileShareService.getImageAsBlob(
                  image.objectId,
                  image.objectImageId,
                  image.objectImageEditId,
                  image.filenameExtension,
                  image.isUploaded,
                  pixId
                );
                return {
                  ...image,
                  imageIndex: index,
                  mainImageUrl: blobUrl,
                  thumbnailUrl: blobUrl
                };
              } catch (error) {
                return {
                  ...image,
                  imageIndex: index,
                  mainImageUrl: '/core/img/errorimage.png',
                  thumbnailUrl: '/core/img/errorimage.png'
                };
              }
            } else {
              // 画像がない場合
              return {
                ...image, 
                imageIndex: index,
                mainImageUrl: '/core/img/misatsuei.png',
                thumbnailUrl: '/core/img/misatsuei.png'
              };
            }
          });
          
          const processedImages = await Promise.all(imagePromises);
          
          // メイン画像URLの配列として設定
          const imageUrls = processedImages.map(img => img.mainImageUrl);
          setImages(imageUrls);
          setImageData(processedImages); // 詳細データも保存
          setImageLength(processedImages.length);

          // 最初の画像を選択
          if (processedImages.length > 0) {
            setCurrentImageIndex(0);
            // 1枚目の画像のタグのみを読み込み（初期表示の高速化）
            const firstImage = processedImages[0];
            if (firstImage.objectId !== undefined 
              && firstImage.objectImageId !== null && firstImage.objectImageId !== '') {
              loadImageTags(pixId, firstImage.objectId, firstImage.objectImageId, 0);
            }
          }
          } else {
          // 画像がない場合
          setImages([]);
          setImageData([]);
          setImageLength(0);
        }
        
      } else {
        // 画像がない場合
        setImages([]);
        setImageData([]);
        setImageLength(0);
      }
    } catch (error) {
      handleApiError(new Error('画像の取得に失敗しました。'));
    }
  }, [handleApiError, loadImageTags]);

  /**
   * 動画データの読み込み
   * シェア用の動画一覧を取得し、シェア専用URLを生成
   * @param {string} pixId - PIX ID
   * @param {string} objectId - オブジェクトID
   */
  const loadMovie = useCallback(async (pixId, objectId) => {
    try {
      // 動画一覧を取得
      const movieData = await mobileShareService.getMovieListForShare(objectId, pixId);

      if(movieData.returnCode !== '200'){
        MessageDialog.show('エラー', '動画の取得に失敗しました。', null, 'error');
        return;
      }
      
      if (movieData && movieData.movieList && movieData.movieList.length > 0) {
        const movieList = movieData.movieList;
        
        // 動画データを処理してstateに設定
        const processedMovies = movieList.map((movie, index) => ({
          ...movie,
          movieIndex: index,
          videoUrl: `/pix/movie.action?objectId=${movie.objectId}&objectMovieId=${movie.objectMovieId}&filenameExtension=${movie.filenameExtension}&isShareFlg=true&sharePixId=${pixId}`,
          videoId: `v_${movie.objectId}_${movie.objectMovieId}`,
          thumbnailUrl: `/pix/movie.action?objectId=${movie.objectId}&objectMovieId=${movie.objectMovieId}&filenameExtension=${movie.filenameExtension}&thumbnail=true&isShareFlg=true&sharePixId=${pixId}`,
          satsueiKanryoJikoku: movie.satsueiKanryoJikoku || '',
          latitude: movie.latitude || '',
          longitude: movie.longitude || ''
        }));
        
        setMovies(processedMovies);
        
        // 最初の動画を選択
        if (processedMovies.length > 0) {
          setCurrentMovieIndex(0);
          handleMovieSelect(0);
        }
        
      } else {
        // 動画がない場合
        setMovies([]);
      }
      
    } catch (error) {
      handleApiError(new Error('動画の取得に失敗しました。'));
    }
  }, [handleApiError, handleMovieSelect]);

  /**
   * オブジェクト詳細データの読み込み
   * シェア用のオブジェクト詳細情報を取得し、フォームデータを設定
   * @param {string} pixId - PIX ID
   * @param {string} objectId - オブジェクトID
   */
  const loadOd = useCallback(async (pixId, objectId) => {
    try {
      // まず撮影メモカテゴリー、拠点、画像フォルダを取得
      const [count, categories, folders] = await Promise.all([
        mobileShareService.getObjectCountForShare(objectId, pixId),
        mobileShareService.getSatsueiMemoCategories(pixId),
        mobileShareService.getImageFolders(objectId, pixId)
      ]);

       if(count.objectCount === 0){
         // 共有者により削除されている場合のダイアログ
         MessageDialog.show(
           'メッセージ',
           '共有者により削除されています。',
           () => {
             // ダイアログを閉じた後にウィンドウを閉じる
             window.open('about:blank','_self').close();
           }
         );
         return;
       }
      
        // その後、オブジェクト情報を取得
        const objectData = await mobileShareService.getObjectDetailForShare(objectId, null, pixId);

        if(objectData.returnCode !== '200'){
          MessageDialog.show('エラー', '撮影データの取得に失敗しました。', null, 'error');
          return;
        }
        
        // オブジェクトデータの設定
        if (objectData) {
          const object = objectData;

          // ドロップダウンオプションの設定
          if (categories) {
            const category = categories.satsueiMemoCategoryList.find(cat => cat.satsueiMemoCategoryId == object.satsueiMemoCategoryId);
            setSatsueiMemoCategories([categories.satsueiMemoCategoryList[0], category]);
            setSatsueiMemoCategory(object.satsueiMemoCategoryId || categories.satsueiMemoCategoryList[0].satsueiMemoCategoryId);
          
            // 撮影ガイドの読み込み
            const guides = await mobileShareService.getSatsueiGuides(object.satsueiMemoCategoryId, pixId);

            if(guides.returnCode !== '200'){
              MessageDialog.show('エラー', '撮影ガイドの取得に失敗しました。', null, 'error');
            }

            setSatsueiGuides(guides.satsueiGuideList);
            setSatsueiGuide(object.satsueiGuideId || '');
          }
          if (object.kyotenId && object.kyotenName) {
            setKyotenName(object.kyotenName);
          }
          if (folders) {
            const folderList = [folders.imageFolderList['0']];
            setHozonFolders(folderList);
            setHozonFolder(object.imageFolderId || 99);
            
            // 各フォルダの画像枚数を計算
            if (folderList.length > 0) {
              await calculateFolderImageCounts(folderList, pixId, objectId);
            }
          }
          
          // 撮影メモカラムの設定
          setSatsueiMemoColumns(object.satsueiMemoColumnDataList || []);
          
          // 画像・動画情報の設定
          setImages(object.objectImages || []);
          setImageLength(object.objectImages?.length || 0);
        } 
      
    } catch (error) {
      handleApiError(new Error('撮影データの取得に失敗しました。'));
    }
  }, [handleApiError, calculateFolderImageCounts]);

  /**
   * データ初期化処理
   * コンポーネントマウント時にシェア情報を取得し、関連データを読み込み
   */
  const initializeData = useCallback(async () => {
    setIsLoading(true);

    try {
      if (shareCode) {
        const shareData = await mobileShareService.getShareInfo(shareCode);
        
        // ビジネスロジックエラーのチェック
        if (shareData.returnCode !== '200') {
          MessageDialog.show('エラー', '撮影データの取得に失敗しました。', null, 'error');
          return;
        }
        
        setObjectId(shareData.objectId);
        setPixId(shareData.pixId);
        
        // オブジェクト詳細を読み込み
        await loadOd(shareData.pixId, shareData.objectId);
        await loadImage(shareData.pixId, shareData.objectId); // 画像読み込み
        await loadMovie(shareData.pixId, shareData.objectId); // 動画読み込み
      }
      
    } catch (error) {
      handleApiError(new Error('撮影データの取得に失敗しました。'));
    } finally {
      setIsLoading(false);
    }
  }, [shareCode, handleApiError, loadOd, loadImage, loadMovie]);
  
  // コンポーネント初期化
  useEffect(() => {
      initializeData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // 画像選択時の処理
  const handleImageSelect = async (imageIndex) => {
    if (imageData && imageData[imageIndex]) {
      const selectedImage = imageData[imageIndex];
      
      // 既に同じ画像が選択されている場合は処理をスキップ
      if (currentImageIndex === imageIndex) {
        return;
      }
      
      // 現在の画像インデックスを設定
      setCurrentImageIndex(imageIndex);
      
      // 画像タグの取得と表示
      if (selectedImage.objectId && selectedImage.objectImageId !== null 
        && selectedImage.objectImageId !== undefined && selectedImage.objectImageId !== '') {
        try {
          const tagData = await mobileShareService.getObjectImageTag(selectedImage.objectId, selectedImage.objectImageId, pixId);
      
          if(tagData.returnCode !== '200'){
            // エラーの場合は空配列を設定
            setImageTags(prev => ({
              ...prev,
              [imageIndex]: []
            }));
            return;
          }
        
          // レスポンスからimageTagListを取得し、imageTagId順にソートしてimageTagプロパティの配列に変換
          if (tagData.imageTagList && tagData.imageTagList.length > 0) {
            const sortedTags = tagData.imageTagList
              .sort((a, b) => a.imageTagId - b.imageTagId)
              .map(tag => tag.imageTag);
            
            // 指定された画像のタグを更新
            setImageTags(prev => {
              const newTags = {
                ...prev,
                [imageIndex]: sortedTags
              };
              return newTags;
            });
          } else {
            // タグがない場合は空配列を設定
            setImageTags(prev => ({
              ...prev,
              [imageIndex]: []
            }));
          }
        } catch (error) {
          // エラーの場合は空配列を設定
          setImageTags(prev => ({
            ...prev,
            [imageIndex]: []
          }));
        }
      }
    }
  };

  // 画像モードへの切り替え
  const handleSwitchImage = () => {
    setSelectFlg(0);
  };

  // 動画モードへの切り替え
  const handleSwitchMovie = () => {
    setSelectFlg(1);
    // 既に動画データがある場合は、最初の動画を選択
    if (movies.length > 0) {
      handleMovieSelect(0);
    }
  };

  // サムネイルクリック処理
  const handleThumbnailClick = (index) => {
    handleImageSelect(index);
  };

  // 動画サムネイルクリック処理
  const handleMovieThumbnailClick = (index) => {
    setCurrentMovieIndex(index);
    handleMovieSelect(index);
  };

  // レンダリング関数群
  const renderImageArea = () => {
    return (
      <div style={styles.imageArea}>
        {images.length !== 0 ? (
          <div style={styles.imageMainAreaTop}>
            <div style={styles.satsueiKanryoJikoku}>
              {imageData[currentImageIndex]?.satsueiKanryoJikoku || ''}
            </div>
            <div style={styles.satsueiMaisu}>
             {currentImageIndex + 1}枚目 / 全{imageLength}枚
            </div>
          </div>
        ) : null}
      
      {images.length === 0 ? (
        <div style={styles.imageMainAreaMisatsuei}>
          <div style={styles.misatsuei}>
            <div style={styles.message}>まだ写真を撮影していません</div>
          </div>
        </div>
      ) : (
        <div style={styles.imageMainArea}>
          <img 
            src={images[currentImageIndex]} 
            alt="メイン画像"
            data-testid="image-main"
            style={styles.imageMain}
            onError={(e) => {
              e.target.src = '/core/img/errorimage.png';
            }}
          />
        </div>
      )}
      
      {(() => {
        const currentTags = imageTags[currentImageIndex];
        return currentTags && currentTags.length > 0 ? (
          <div style={styles.imageTagArea}>
            <div style={styles.imageTag}>
              {currentTags.map((tag, index) => (
                <span key={index} style={styles.tagItem}>
                  {tag}
                </span>
              ))}
            </div>
          </div>
        ) : null;
      })()}

      {images.length > 1 && (
      <div style={styles.imageMainAreaBottom}>
        <div style={styles.satsueiBasho}>
          {imageData[currentImageIndex]?.latitude}-{imageData[currentImageIndex]?.longitude}
        </div>
      </div>
      )}
      
      {images.length > 1 && (
        <div style={styles.imageThumbnailArea}>
          <ul style={styles.imageThumbnail}>
            {imageData.map((image, index) => (
              <li 
                key={index}
                style={{
                  ...styles.thumbnailItem,
                  borderColor: index === currentImageIndex ? '#F93535' : '#ddd'
                }}
                onClick={() => handleThumbnailClick(index)}
              >
                <img 
                  src={image.thumbnailUrl || image.mainImageUrl} 
                  alt={`サムネイル ${index + 1}`}
                  style={styles.thumbnailImage}
                  onError={(e) => {
                    e.target.src = '/core/img/errorimage.png';
                  }}
                />
              </li>
            ))}
          </ul>
        </div>
      )}
      </div>
    );
  };

  // 動画エリアのレンダリング
  const renderMovieArea = () => {
    return (
      <div style={styles.movieArea}>
        {movies.length === 0 ? (
          <div style={styles.movieMainAreaMisatsuei}>
            <div style={styles.misatsuei}>
              <div style={styles.message}>まだ動画を撮影していません</div>
            </div>
          </div>
        ) : (
          <>
            <div style={styles.movieMainArea}>
              <video 
                src={movies[currentMovieIndex]?.videoUrl || ''} 
                controls
                style={styles.movieMain}
                data-testid="movie-main"
              />
            </div>
            
            {movies.length > 1 && (
              <div style={styles.movieThumbnailArea}>
                <ul style={styles.movieThumbnail}>
                  {movies.map((movie, index) => (
                    <li 
                      key={index}
                      style={{
                        ...styles.movieThumbnailItem,
                        borderColor: index === currentMovieIndex ? '#F93535' : '#ddd'
                      }}
                      onClick={() => handleMovieThumbnailClick(index)}
                    >
                      <img 
                        src={movie.thumbnailUrl || '/core/img/movie-placeholder.png'} 
                        alt={`動画サムネイル ${index + 1}`}
                        style={styles.movieThumbnailImage}
                        onError={(e) => {
                          e.target.src = '/core/img/errorimage.png';
                        }}
                      />
                      <div style={styles.moviePlayIcon}></div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  return (
    <div style={styles.container}>
      {/* ローディング中の場合はローディング画面を表示 */}
      {isLoading ? (
        <div style={styles.loading}>
          <div>読み込み中...</div>
        </div>
      ) : (
        <>
        {/* Header */}
        <div style={styles.detailHeader}>
          <div style={styles.headerLeft}>
            <div style={styles.logoArea}>
              <img 
                src="/core/img/pix-label_logo_250_100.png" 
                alt="pix-label"
                style={styles.logoImage}
              />
            </div>
          </div>
        </div>
  
        {/* Image/Movie Switch Header */}
        <div style={styles.imageMainAreaHeader}>
          <div style={{height: '44px'}}>
            <div style={styles.headerLeft}>
              <div 
                style={{
                  ...styles.switchImageButtonArea,
                  backgroundColor: selectFlg === 0 ? '#f93535' : '#EEE',
                  backgroundSize: 'contain'
                }}
                onClick={handleSwitchImage}
                data-testid="switch-image-button"
              >
                <div style={styles.switchImageButton}></div>
              </div>
              <div 
                style={{
                  ...styles.switchMovieButtonArea,
                  backgroundColor: selectFlg === 1 ? '#f93535' : '#EEE',
                  backgroundSize: 'contain'
                }}
                onClick={handleSwitchMovie}
                data-testid="switch-movie-button"
              >
                <div style={styles.switchMovieButton}></div>
              </div>
            </div>
            <div style={styles.headerRight}>
              <div style={styles.code}>[SHARE CODE]  {shareCode}</div>
            </div>
          </div>

          <div>
            <div style={{...styles.select, backgroundColor: '#f5f5f5', color: '#666'}} data-testid="hozon-folder-select">
              {hozonFolder === 99 ? `全選択 (${totalImageCount})` :
                `${hozonFolders.find(folder => folder.imageFolderId === hozonFolder)?.imageFolderName || '全フォルダ表示'} (${folderImageCounts[hozonFolder] || 0})`}
            </div>
          </div>
        </div>
  
        {/* Image Area - 画像モードの時のみ表示 */}
        {selectFlg === 0 && renderImageArea()}
  
        {/* Movie Area - 動画モードの時のみ表示 */}
        {selectFlg === 1 && renderMovieArea()}
  
        {/* Selectors - 閲覧専用 */}
        <div style={styles.selector}>
          <div style={styles.satsueiMemoCategoryArea}>
            <div style={styles.satsueiMemoCategoryAreaTitle}>
              撮影メモカテゴリー
            </div>
            <div style={{...styles.select, backgroundColor: '#f5f5f5', color: '#666'}} data-testid="satsuei-memo-category-select">
              {satsueiMemoCategories.find(cat => cat.satsueiMemoCategoryId == satsueiMemoCategory)?.satsueiMemoCategoryName || '未選択'}
            </div>
          </div>
  
          {satsueiGuides.length > 0 && (
            <div style={styles.satsueiGuideArea}>
              <div style={styles.satsueiGuideAreaTitle}>
                撮影ガイド
              </div>
              <div style={{...styles.select, backgroundColor: '#f5f5f5', color: '#666'}} data-testid="satsuei-guide-select">
                {satsueiGuides.find(guide => guide.satsueiGuideId == satsueiGuide)?.satsueiGuideName || '未選択'}
              </div>
            </div>
          )}
  
          <div style={styles.kyotenListArea}>
            <div style={styles.kyotenListAreaTitle}>
              拠点
            </div>
            <div style={{...styles.select, backgroundColor: '#f5f5f5', color: '#666'}} data-testid="kyoten-select">
              {kyotenName || '未選択'}
            </div>
          </div>
        </div>

        {/* Memo Area - 撮影ラベル */}
        <div style={styles.satsueiMemoArea}>
          <div style={styles.satsueiMemoAreaTitle} data-testid="satsuei-memo-area-title">
            撮影ラベル
          </div>
          {satsueiMemoColumns.length > 0 ? (
            <SatsueiMemoForm
              objectId={objectId}
              satsueiMemoColumns={satsueiMemoColumns}
              readOnly={true}
            />
          ) : (
            <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
              撮影メモカテゴリーを選択してください
            </div>
          )}
        </div>
        </>
      )}
      
      {/* Error Dialog */}
      <MessageDialog
        isOpen={showErrorDialog}
        onClose={closeErrorDialog}
        title="エラー"
        message={errorMessage}
        type="error"
      />
    </div>
  );
};

export default AppShare;
